export default "__VITE_ASSET__CGA$dRMD__"